export const UPDATE_LIVE_SESSIONS_INTERVAL = 30 * 1000;
